import nBossConnection from 'modules/base/service/nBossConnection';

class LabConnectionService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'labConnectionControl';
	}

	/**
	 * @return {Promise<NamedDto[]>}
	 */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data || []))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<any>}
	 */
	getLocations(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getLocations`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<any>}
	 * @param {number} id
	 * @param {string} location
	 */
	getSamplingPointsByLocation(id, location) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getSamplingPointsByLocation`, {
					id,
					location
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<any>}
	 * @param {number} id
	 * @param {string} samplingPoint
	 */
	getAnalysisForSamplingPoint(id, samplingPoint) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getAnalysisForSamplingPoint`, {
					id,
					samplingPoint
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<any>}
	 * @param {number} id
	 * @param {string} samplingPoint
	 * @param {string} analysis
	 */
	getAnalysisInfo(id, samplingPoint, analysis) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getAnalysisInfo`, {
					id,
					samplingPoint,
					analysis
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new LabConnectionService();
